<template>
  <div>
    <strong style="font-size: 14px">
      <i class="el-icon-circle-plus"></i> Thêm cấu hình
    </strong>

    <div style="margin-top: 20px">
      <p class="text-title"> {{ $t('ads.configuration_active_day') }} </p>
      <div style="display: flex; gap: 10px; margin-top: 10px; align-items: center">
        <el-select style="width: 200px" size="mini" value="" filterable
                   v-model="form_auto_schedule.day">
          <el-option value="flash_sale" :label="$t('day.flash_sale')"></el-option>
          <el-option value="before_flash_sale" :label="$t('day.before_flash_sale')"></el-option>
          <el-option value="after_flash_sale" :label="$t('day.after_flash_sale')"></el-option>
          <el-option value="mini_spike_day" :label="$t('day.mini_spike_day')"></el-option>
          <el-option value="day" :label="$t('day.specific_day')"></el-option>
          <el-option value="remain" :label="$t('day.every_day')"></el-option>
          <el-option value="exclude_sale" :label="$t('day.exclude_sale')"></el-option>
          <el-option value="from_to" :label="$t('day.from_to')"></el-option>
        </el-select>
        <el-input
          v-if="['before_flash_sale', 'after_flash_sale', 'day'].includes(form_auto_schedule.day)"
          style="width: 200px" size="mini" type="number" :label="$t('input.day_numbers')"
          v-model="form_auto_schedule.day_number"
          :disabled="['mini_spike_day', 'flash_sale', 'remain', 'exclude_sale'].includes(form_auto_schedule.day)">
        </el-input>
        <el-date-picker v-if="['from_to'].includes(form_auto_schedule.day)"
                        v-model="form_auto_schedule.date_range" type="daterange" range-separator="-"
                        :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
                        format="dd-MM-yyyy" :clearable="false" style="width: 300px">
        </el-date-picker>

        <div style="padding-top: 6px">
          <el-checkbox v-if="['from_to'].includes(form_auto_schedule.day)"
                       v-model="form_auto_schedule.allow_repeat_monthly" style="margin-left: 20px">
            {{ $t('voucher.allow_repeat_monthly') }}
          </el-checkbox>
        </div>
      </div>
    </div>

    <div style="margin-top: 20px">
      <p class="text-title"> {{ $t('flash_sale.runtime') }} </p>
      <div style="margin-top: 10px; display: flex; gap: 10px">
        <el-time-select
          style="width: 200px"
          v-model="form_auto_schedule.start_time"
          size="mini"
          :picker-options="{start: '00:00',step: '00:15',end: '24:00'}"
          :placeholder="$t('base.starting_time')">
        </el-time-select>
        <el-time-select
          style="width: 200px"
          v-model="form_auto_schedule.end_time"
          size="mini"
          :picker-options="{start: '00:00',step: '00:15',end: '24:00'}"
          :placeholder="$t('base.ending_time')">
        </el-time-select>
        <el-button type="primary" size="mini" icon="el-icon-plus"
                   @click="m__form_auto_schedule_add_time"></el-button>
      </div>
      <div style="margin-top: 20px" class="table">
        <div v-for="(item, index) in form_auto_schedule.times" :key="index"
             style="display: flex; margin-bottom: 5px; align-items: center">
          <div style="width: 200px">{{ $t('base.from') }}: {{ item.start_time }}</div>
          <div style="width: 20px">-</div>
          <div style="width: 200px">{{ $t('base.to') }}: {{ item.end_time }}</div>
          <div style="width: 100px" class="text-right">
            <el-button size="mini" type="danger" icon="el-icon-delete"
                       @click="form_auto_schedule.times.splice(index, 1)"></el-button>
          </div>
        </div>
      </div>
    </div>

    <div style="margin-top: 30px; display: flex; gap: 10px">
      <div style="margin-right: 15px">
        <el-dropdown trigger="click" @command="m__show_config_schedule">
          <el-tag type="info" size="medium" effect="plain">Chọn cấu hình tự động <i class="el-icon-plus"></i></el-tag>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="auto_position">
              Duy trì vị trí tự động
            </el-dropdown-item>
            <el-dropdown-item command="auto_cir">
              Tối ưu theo CIR tự động
            </el-dropdown-item>
            <el-dropdown-item command="anti_click">
              Chống click ảo
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div v-for="(item, item_index) of form_auto_schedule.config_list" style="margin-bottom: 10px">
        <el-tag size="medium" type="success" style="cursor: pointer" closable
                @close="m__delete_form_config_list_item(item_index)"
                @click="m__show_detail_config_schedule(item)">
          <template v-if="item.type === 'auto_position'">Cấu hình duy trì vị trí tự động</template>
          <template v-if="item.type === 'auto_cir'">Cấu hình tối ưu theo CIR</template>
          <template v-if="item.type === 'anti_click'">Cấu hình chống click ảo</template>
        </el-tag>
      </div>
    </div>

    <div style="margin-top: 30px">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="m__add_schedule_item()">Thêm cấu hình
      </el-button>
    </div>

    <div style="margin-top: 60px">
      <strong style="font-size: 14px">
        <i class="el-icon-menu"></i> Danh sách lịch trình tự động
      </strong>

      <div style="margin-top: 20px">
        <el-table :data="config_schedule_list">
          <el-table-column label="Thời gian chạy">
            <template slot-scope="scope">
              {{ spike_day_map(scope.row, false) }}

              <div v-for="time in scope.row.times">
                {{ time.start_time }} - {{ time.end_time }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Cấu hình tự động">
            <template slot-scope="scope">
              <div v-for="item of scope.row.config_list" style="margin-bottom: 10px">
                <el-tag size="small" type="success" style="cursor: pointer"
                        @click="m__show_detail_config_schedule(item)">
                  <template v-if="item.type === 'auto_position'">Cấu hình duy trì vị trí tự động</template>
                  <template v-if="item.type === 'auto_cir'">Cấu hình tối ưu theo CIR</template>
                  <template v-if="item.type === 'anti_click'">Cấu hình chống click ảo</template>
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Tùy chọn" width="150px" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini">
                <strong class="text-danger">{{ $t('base.delete') }}</strong>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div style="margin-top: 30px" class="text-right">
      <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.update_config"
                 @click="m__update_auto_schedule_config()">Lưu cấu hình
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'config_schedule_component',

  props: {
    shop: null,
    sp_user: null,
    show_dialog: false,
    level: null,
    campaign_type: null,
    campaign_ids: null,
    keywords: null,
    placements: null
  },

  data() {
    return {
      tab: '0',
      list: [],

      form_auto_schedule: {
        day: 'from_to',
        day_number: '',
        times: [],
        date_range: [new Date(), new Date()],
        allow_repeat_monthly: true,
        config_list: []
      },

      loading: {
        update_config: false
      },

      config_schedule_list: []
    }
  },

  beforeMount() {
    this.EB.$on('add_config_schedule', (data) => {
      console.log('add_config_schedule data', data)
      this.form_auto_schedule.config_list.push(data)
    })
  },

  watch: {
    'show_dialog': function () {
      if (this.show_dialog) this.m__get_auto_schedule_config()
    }
  },

  methods: {
    m__add_schedule_item() {
      if (!this.form_auto_schedule.times.length) {
        this.ntf_w('Vui lòng chọn thời gian hoạt động')
        return
      }
      if (!this.form_auto_schedule.config_list.length) {
        this.ntf_w('Vui lòng chọn cấu hình tự động')
        return
      }

      this.config_schedule_list.push(this.clone({
        type: this.form_auto_schedule.day,
        ...this.form_auto_schedule
      }))
      console.log(this.config_schedule_list)
    },

    m__delete_form_config_list_item(index) {
      this.form_auto_schedule.config_list.splice(index, 1)
    },

    m__show_config_schedule(type) {
      this.EB.$emit('show_config_schedule', {
        type: type,
        action: 'schedule',
      })
    },

    m__show_detail_config_schedule(item) {
      this.EB.$emit('show_config_schedule', {
        type: item.type,
        json: item.json,
        action: 'see_detail',

      })
    },

    m__form_auto_schedule_add_time() {
      if (!this.form_auto_schedule.start_time || !this.form_auto_schedule.end_time) {
        return
      }

      this.form_auto_schedule.times.push({
        start_time: this.form_auto_schedule.start_time,
        end_time: this.form_auto_schedule.end_time
      })
      this.form_auto_schedule.start_time = ''
      this.form_auto_schedule.end_time = ''
    },

    async m__get_auto_schedule_config() {
      this.config_schedule_list = []
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_schedule/get', {
        shop_id: this.shop._id,
        campaign_ids: this.campaign_ids
      }, this.cf())

      if (response && response.body && response.body.data && response.body.data.length && response.body.data[0].config_list) {
        this.config_schedule_list = typeof response.body.data[0].config_list === 'string'
          ? JSON.parse(response.body.data[0].config_list)
          : response.body.data[0].config_list

        console.log(this.config_schedule_list)
      }
    },

    async m__update_auto_schedule_config() {
      try {
        await this.$confirm(this.$t('base.save_config_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.update_config = true
      try {
        const form = {
          shop_id: this.shop._id,
          campaign_ids: this.campaign_ids,
          keywords: [],
          placements: [],
          config_list: JSON.stringify(this.config_schedule_list)
        }

        if (this.campaign_type === 'search' && this.keywords) {
          form.keywords = this.keywords.map(item => item.keyword && item.checked)
        }
        if (this.campaign_type === 'targeting' && this.placements) {
          form.placements = this.placements
        }

        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_schedule/update', form, this.cf())
        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.update_config = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/component/component_config_schedule.vue